import { Injectable, SecurityContext } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { LogService } from './log.service';
import * as DOMPurify from 'dompurify';

@Injectable({
	providedIn: 'root',
})
export class ErrorWafConverterService {

	private LOG: LogService = new LogService(ErrorWafConverterService);

	private controlNameList: any[] = [];
	constructor() { }

	public getControlNameList() {
		return this.controlNameList;
	}

	public convertErrorWaf(form) {
		if (environment.waf === 'true') {
			let errorWafMap = new Map<string, string>();
			for (var value in environment.convert_error_waf) {
				errorWafMap.set(value, environment.convert_error_waf[value]);
			}
			this.controlNameList.forEach((controlName) => {
				errorWafMap.forEach((value, key) => {
					form.controls[controlName]?.setValue(form.controls[controlName].value instanceof Array ? form.controls[controlName].value.map((x) => x.replaceAll(new RegExp(value, "ig"), key)) : form.controls[controlName].value?.replaceAll(new RegExp(value, "ig"), key));
				});
			})
		}
	}

	public deconvertErrorWaf(form) {
		if (environment.waf === 'true') {
			let errorWafMap = new Map<string, string>();
			for (var value in environment.deconvert_error_waf) {
				errorWafMap.set(value, environment.deconvert_error_waf[value]);
			}
			this.controlNameList.forEach((controlName) => {
				errorWafMap.forEach((value, key) => {
					form.controls[controlName]?.setValue(form.controls[controlName].value instanceof Array ? form.controls[controlName].value.map((x) => x.replaceAll(key, value)) : form.controls[controlName].value?.replaceAll(key, value));
				});
			})
		}
	}

	public sanitize(form) {
		this.controlNameList.forEach((controlName) => {
			form.controls[controlName]?.setValue(form.controls[controlName].value instanceof Array ? form.controls[controlName].value.map((x) => DOMPurify.sanitize(x)) : DOMPurify.sanitize(form.controls[controlName].value));
		})
	}

	public clear() {
		this.controlNameList = [];
	}
}
